import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { IGetPhoneCenterViadID } from '../phoneCenter';


const getPhoneCenter = (PhoneCenterId: number | undefined): Promise<IGetPhoneCenterViadID> => {
  return axiosDefaultApi.get(`/api/PhoneCenters/GetPhoneCenterViaID/${PhoneCenterId}`);
};

type QueryFnType = typeof getPhoneCenter;

type UseGetPhoneCenterOptions = {
  PhoneCenterId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPhoneCenter = ({ PhoneCenterId , config }: UseGetPhoneCenterOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPhoneCenter_${PhoneCenterId}`],
    queryFn: () => getPhoneCenter(PhoneCenterId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Τηλεφωνικού Κέντρου.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};